import { useContext } from "react";
import { RankifierStateContext } from "../contexts/rankifier/rankifierState";

export const useRankifierState = () => {
  const context = useContext(RankifierStateContext);
  if (!context) {
    throw new Error("useRankifierState must be used within a RankifierContextProvider");
  }
  return context;
};
